<template>
	<div>
		<b-form-select
			:type="type"
			v-model="proxyValue"
			:value-field="valueKey"
			:state="state"
			:text-field="valueText"
			@blur.native="emitBlur"
			:disabled="!active"
		>
			<template v-slot:first>
				<option v-for="option in internOptions" :key="option[valueKey]" :value="option[valueKey]" :title="option[valueText]">
					{{ option[valueText]?.length > 170 ? option[valueText].slice(0, 170) + "..." : option[valueText] }}
				</option>
			</template>
		</b-form-select>

		<b-form-invalid-feedback :id="`${name}-feedback`">
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String
		},

		options: {
			type: [Array, Function],
			required: true
		},
		name: {
			type: String
		},
		value: {
			required: false
		},

		valueKey: {
			type: String
		},

		valueText: {
			type: String
		},
		state: {
			type: Boolean,
			default: null
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		returnKey: {
			type: Boolean
		}
	},
	data() {
		return {
			active: true,
			internOptions: []
		};
	},
	computed: {
		proxyValue: {
			get() {
				if (!this.value) return undefined;

				if (!this.returnKey) return this.value[this.valueKey];
				return this.value;
			},
			set(newValue) {
				if (!this.returnKey) {
					let selectedObject = this.options.find((o) => o[this.valueKey] == newValue);
					this.$emit("input", selectedObject);
					this.$emit("change", this.name);

					return;
				}
				this.$emit("input", newValue);
				this.$emit("change", this.name);
			}
		}
	},
	methods: {
		emitBlur: function () {
			this.$emit("blur", this.name);
		},
		parentChanged: function (parentValue) {
			if (typeof this.options == "function") {
				this.internOptions = this.options(parentValue);
			}
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		}
	},
	watch: {
		options() {
			this.internOptions = this.options;
		}
	},
	beforeMount() {
		if (typeof this.options == "function") this.internOptions = this.options(null);
		else this.internOptions = this.options;

		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	}
};
</script>
